import '.fv{color:var(--shades-red-500);}.ssr-plugin'
import '.fw{background-color:var(--shades-gray-200);}.ssr-plugin'
import '.db{border-radius:0.625rem;}.ssr-plugin'
import '.fx{min-height:200px;}.ssr-plugin'
import '.g{display:flex;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.aa{overflow:hidden;}.ssr-plugin'
import '.fy{box-shadow:0 4px 6px -1px rgba(0, 0, 0, 0.1);}.ssr-plugin'
import { useEffect, useState } from 'react'
import { oembed } from '@loomhq/loom-embed'
import { Style, styled } from 'inlines'

type OEmbedData = Awaited<ReturnType<typeof oembed>>

export interface LoomVideoProps {
  src: string
  style?: Style
  className?: string
}

export const LoomVideo = ({ src, style, className }: LoomVideoProps) => {
  const [embedData, setEmbedData] = useState<OEmbedData>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let isMounted = true

    async function fetchEmbed() {
      if (!src) {
        return
      }

      try {
        const data = await oembed(src)

        if (isMounted) {
          setEmbedData(data)
          setError(null)
        }
      } catch (e) {
        if (isMounted) {
          console.error('Failed to load Loom video:', e)
          setError('Failed to load video')
        }
      }
    }

    void fetchEmbed()

    return () => {
      isMounted = false
    }
  }, [src])

  if (error) {
    return (
      <styled.div className={`${className} fv`}
        style={{ ...style }}
      >
        {error}
      </styled.div>
    )
  }

  if (!embedData) {
    return (
      <styled.div className={`${className} fw db fx g b i`}
        style={{
          ...style,
        }}
      >
        Loading...
      </styled.div>
    )
  }

  return (
    <styled.div className={`${className} db aa fy`}
      style={{
        ...style,
      }}
      dangerouslySetInnerHTML={{ __html: embedData.html }}
    />
  )
}
